import React, { useState, useContext } from 'react';
import '../App.css';
import { HomeDataContext } from "../contexts/HomeDataContext";
import { homeDataService } from "../services/HomeDataService";

function LoadingOverlay() {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="loading-spinner w-12 h-12 rounded-full border-t-4 border-blue-500 animate-spin"></div>
    </div>
  );
}

function Prompts() {
  const [inputs, setInputs] = useState(['']);
  const { homeDataState, dispatch } = useContext(HomeDataContext);

  const handleInputChange = (index, event) => {
    const values = [...inputs];
    values[index] = event.target.value;
    setInputs(values);
  };

  const handleAddInput = () => {
    setInputs([...inputs, '']);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = {
      inputs: inputs
    };
    console.log(data);
    await homeDataService.prompts(dispatch, data);
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      {homeDataState.loading && <LoadingOverlay />}
      <div className="flex-1 p-8">
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">Prompt Adjustments</h2>
        <form onSubmit={handleSubmit} className="bg-gray-100 rounded-lg p-6 space-y-4">
          {inputs.map((input, index) => (
            <div key={index} className="mb-4">
              <label className="block text-gray-600 text-sm font-bold mb-2">
                Input {index + 1}:
              </label>
              <input
                className="shadow-none appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                value={input}
                onChange={(event) => handleInputChange(index, event)}
              />
            </div>
          ))}
          <div className="flex items-center justify-between">
            <button
              type="button"
              className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              onClick={handleAddInput}
            >
              + add input
            </button>
          </div>
          <div className="form__group flex flex-col items-center">
            <button
             	className="button button--primary w-[10%]"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>

        <div className="mt-8">
          <label className="block text-gray-600 text-sm font-bold mb-2">
            Response Result:
          </label>
          <textarea
            className="shadow-none appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            value={homeDataState.promptResult|| ''}
            readOnly
            rows="10"
          />
        </div>

      </div>
    </div>
  );
}

export default Prompts;